<script>
import { mapGetters } from 'vuex';

import CostService from "@/store/services/cost.service.js";
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountsSupplier",
  extends: TotalAmountsBase,
  data() {
    return {
      mutationName: 'filterStore/SET_UPDATE_FILTER_SUPPLIER_INSIGHT'
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyId: 'main/getCompanyId'
    }),
  },
  methods: {
    getTotalAmounts(){
      if(Object.keys(this.filters).length !== 0){
        this.loading = true
        if(!this.filters.owner_company){
          this.filters.owner_company = this.getCompanyId;
        }

        let filters_costs = {
        'start_date': this.filters.start_date,
        'end_date': this.filters.end_date,
        'group_by': 'supplier',
        'owner_company': this.getCompanyId,
        'tax_exists': true,
        'tax_exempt': true,
        'btw_reversed_charge': true
        }

        CostService.totalNet(filters_costs).then((response) => {
        this.loading = false
        this.amountsList = []
        let paid = 0
        let unpaid = 0
        response.data.forEach((supplier) => paid += supplier.total_net)
        response.data.forEach((supplier) => unpaid += supplier.total_unpaid)
        this.amountsList.push({text: this.$gettext("PAID"), amount: paid, class:'text-brand'})
        this.amountsList.push({text: this.$gettext("UNPAID"), amount: unpaid, class:'text-blue'})
        })
    }
    }
  }
};
</script>